
(function(){
  var btn = document.querySelector('.hm-toggle');
  var overlay = document.getElementById('MobileMenu');
  if(!btn || !overlay) return;
  var closeBtn = overlay.querySelector('.hm-close');
  var firstLink = overlay.querySelector('.hm-links a');

  function openMenu(){
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden','false');
    btn.setAttribute('aria-expanded','true');
    document.body.style.overflow='hidden';
    setTimeout(function(){ firstLink && firstLink.focus(); }, 50);
  }
  function closeMenu(){
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden','true');
    btn.setAttribute('aria-expanded','false');
    document.body.style.overflow='';
    btn.focus();
  }

  btn.addEventListener('click', function(){
    if(overlay.classList.contains('is-open')){ closeMenu(); } else { openMenu(); }
  });
  closeBtn && closeBtn.addEventListener('click', closeMenu);
  overlay.addEventListener('click', function(e){
    if(e.target === overlay){ closeMenu(); }   // click backdrop to close
  });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && overlay.classList.contains('is-open')){ closeMenu(); }
  });
})();
